module.exports = __webpack_public_path__ + "img/MX-B12440-A.abb2c1d8.png";